import type { CSSProperties, ReactNode } from "react";
import { C } from "../theme";

interface CardProps {
  children: ReactNode;
  style?: CSSProperties;
}

/** Cartão padrão do Apogeu (fundo branco, borda suave, cantos arredondados). */
export function Card({ children, style }: CardProps) {
  return (
    <div
      style={{
        background: C.white,
        border: `1px solid ${C.faint}`,
        borderRadius: 14,
        padding: 18,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
